import { Scissors, Flask, Cube, Package, Star, ArrowRight } from "@phosphor-icons/react";

const services = [
  {
    id: 1,
    title: "Impressão e Cortes em MDF",
    description: "Cortes precisos em MDF até 6mm com máquina a laser de alta precisão. Ideal para projetos detalhados e acabamento profissional.",
    image: "https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/024201bf4702ab5d583a63e8d88f8c6c421ad79a1fe2914d4b953239f78b26c9.png",
    icon: Scissors,
    span: "md:col-span-4 lg:col-span-6",
    featured: true,
  },
  {
    id: 2,
    title: "Gravação a Laser",
    description: "Gravamos em copos, garrafas, canetas, chaveiros e muito mais. Personalização única para presentes especiais.",
    image: "https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/d8e7d9d41323db4bfced8cf4f11fed52e85910df94a50c34964aae820a7eed2c.png",
    icon: Flask,
    span: "md:col-span-4 lg:col-span-6",
    featured: true,
  },
  {
    id: 3,
    title: "Inserts de Jogos",
    description: "Organizadores personalizados para seus jogos de tabuleiro favoritos. Mantenha tudo organizado e protegido.",
    image: "https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/06ef52561b071683ae43988a8aa09117da73594164e8d08904b2ac7f215d566c.png",
    icon: Cube,
    span: "md:col-span-4 lg:col-span-4",
  },
  {
    id: 4,
    title: "Caixas Personalizadas",
    description: "Caixas em MDF para qualquer ocasião: presentes, organização, decoração. Tudo feito sob medida.",
    image: "https://images.pexels.com/photos/13625513/pexels-photo-13625513.jpeg",
    icon: Package,
    span: "md:col-span-4 lg:col-span-4",
  },
  {
    id: 5,
    title: "E Muito Mais",
    description: "Placas decorativas, porta-retratos, suportes, e qualquer ideia que você tiver. Criamos juntos!",
    image: null,
    icon: Star,
    span: "md:col-span-4 lg:col-span-4",
    cta: true,
  },
];

const Services = () => {
  return (
    <section 
      id="servicos" 
      className="py-24 px-6 bg-[#03030A]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00E5FF] uppercase tracking-[0.2em] text-sm font-semibold mb-4 block">
            O que fazemos
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Nossos <span className="gradient-text">Serviços</span>
          </h2>
          <p className="text-[#A0AEC0] text-lg max-w-2xl mx-auto">
            Transformamos suas ideias em peças únicas com precisão e qualidade
          </p>
        </div>

        {/* Services Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6 stagger-children">
          {services.map((service) => (
            <div
              key={service.id}
              className={`service-card rounded-2xl overflow-hidden ${service.span} ${
                service.featured ? "min-h-[400px]" : "min-h-[300px]"
              }`}
              data-testid={`service-card-${service.id}`}
            >
              {service.image ? (
                <div className="relative h-full group">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#03030A] via-[#03030A]/60 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-xl bg-[#00E5FF]/10 flex items-center justify-center">
                        <service.icon weight="fill" className="text-[#00E5FF]" size={24} />
                      </div>
                      <h3 className="font-outfit text-xl font-bold text-white">
                        {service.title}
                      </h3>
                    </div>
                    <p className="text-[#A0AEC0] text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="h-full p-6 flex flex-col justify-between bg-gradient-to-br from-[#0C0D14] to-[#03030A] border border-white/5">
                  <div>
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#00E5FF]/20 to-[#D500F9]/20 flex items-center justify-center mb-4">
                      <service.icon weight="fill" className="text-[#00E5FF]" size={28} />
                    </div>
                    <h3 className="font-outfit text-xl font-bold text-white mb-3">
                      {service.title}
                    </h3>
                    <p className="text-[#A0AEC0] text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                  {service.cta && (
                    <a
                      href="https://wa.me/5527981761251?text=Olá! Gostaria de saber mais sobre os serviços."
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-[#00E5FF] font-semibold mt-4 hover:gap-3 transition-all"
                      data-testid="service-cta"
                    >
                      <span>Fale Conosco</span>
                      <ArrowRight weight="bold" size={18} />
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
